import { KeyboardEvent } from 'react';

export const useTabNavigation = () => {
    const handleTabNavigation = (event: KeyboardEvent<HTMLElement>) => {
        if (event.key === 'Tab') {
            const container = document.getElementById('item-editor-body');
            const scope = container ?? document;
            const activeElement = document.activeElement as HTMLElement | null;
            const eventTarget =
                (event.currentTarget as HTMLElement | null) || (event.target as HTMLElement | null);

            const formElements = Array.from(
                scope.querySelectorAll<HTMLElement>('input, select, textarea, button, [tabindex]:not([tabindex="-1"])')
            ).filter(el => {
                const isDisabled = (el as HTMLInputElement).disabled || el.hasAttribute('disabled');
                const isHidden = (el as any).hidden;
                const isAriaHidden = el.getAttribute('aria-hidden') === 'true';
                const style = window.getComputedStyle(el);
                const isActuallyFocused =
                    (!!activeElement && (el === activeElement || el.contains(activeElement))) ||
                    (!!eventTarget && (el === eventTarget || el.contains(eventTarget)));
                const isVisible =
                    style.display !== 'none' &&
                    style.visibility !== 'hidden' &&
                    (style.opacity !== '0' || isActuallyFocused);

                return !isDisabled && !isHidden && !isAriaHidden && isVisible && el.offsetParent !== null;
            });

            if (formElements.length === 0) {
                return;
            }

            let currentIndex = activeElement ? formElements.indexOf(activeElement) : -1;
            if (currentIndex === -1) {
                if (eventTarget) {
                    currentIndex = formElements.findIndex(el => el === eventTarget || el.contains(eventTarget));
                }
            }
            const offset = event.shiftKey ? -1 : 1;
            const nextIndex = currentIndex === -1
                ? (event.shiftKey ? formElements.length - 1 : 0)
                : currentIndex + offset;
            const next = formElements[nextIndex];

            if (next) {
                event.preventDefault();
                next.focus();
            }
        }
    };

    return handleTabNavigation;
};
